import React, { useState, useMemo, useEffect } from "react";

import { defineMessages, FormattedMessage } from "react-intl";
import { usePropertyConfiguration } from "../../components/property-configuration-provider";

import { AccordionMenuItem } from "../../layout/classic/accordion-menu-elements";
import { SECTION } from "../../lib/constants";

import {
  ContainerMenuItemStyled,
  TitleStyled,
  ContainerSection,
  TitleSectionStyled,
  ParagraphStyled,
} from "./form-style";

const messages = {
  ...defineMessages({
    title: {
      id: "menu.inventory.define",
      defaultMessage: "Definir nventario",
    },
    inventoryTitle: {
      id: "menu.inventory.inventoryTitle",
      defaultMessage: "Inventario > ",
    },
  }),
};

type PropAccordionMenu = {
  propertyTicker: string;
};

type SectionMenuType = {
  id: number;
  section: string;
  title: TitleType;
  route?: string;
  href?: string;
};

type TitleType = {
  id: number | string;
  defaultMessage: string;
};

const AccordionMenu = ({ propertyTicker }: PropAccordionMenu) => {
  const [dynamicSections, setDynamicSections] = useState<SectionMenuType[]>([]);

  const propertyConfiguration = usePropertyConfiguration();

  useEffect(() => {
    const createDynamicMenuSections = () => {
      const newDynamicValues: SectionMenuType[] = [];
      newDynamicValues.push({
        id: 1,
        section: SECTION.ACCOMMODATIONS,
        route: "accommodations",
        title: {
          id: "define.inventory.accommodation",
          defaultMessage: "Alojamientos",
        },
      });

      if (propertyConfiguration?.occupationType !== "PAX_TYPE") {
        newDynamicValues.push({
          id: 2,
          section: SECTION.BUNDLES,
          route: "bundles",
          title: {
            id: "define.inventory.packages",
            defaultMessage: "Packages",
          },
        });
      }

      newDynamicValues.push({
        id: 7,
        section: SECTION.INVENTORY_LINES,
        route: "batch-inventory",
        title: {
          id: "define.inventory.inventoryLine",
          defaultMessage: "Crear lineas de inventario por lotes",
        },
      });

      newDynamicValues.push({
        id: 8,
        section: SECTION.INVENTORY_LINES,
        route: "inventory-table",
        title: {
          id: "define.inventory.tablaInventario",
          defaultMessage: "Tabla de inventario",
        },
      });
      setDynamicSections(newDynamicValues);
    };
    createDynamicMenuSections();
  }, [propertyConfiguration, propertyTicker]);

  const menuSections = useMemo(
    () => [
      {
        id: 3,
        section: SECTION.OCCUPATIONS,
        href: `occupation`,
        title: {
          id: "define.inventory.ocupaciones",
          defaultMessage: "Ocupaciones",
        },
      },
      {
        id: 5,
        section: SECTION.CONDITIONS,
        route: "conditions",
        title: {
          id: "define.inventory.conditions",
          defaultMessage: "Condiciones",
        },
      },
      {
        id: 6,
        section: SECTION.MEAL_PLANS,
        route: "mealplan",
        title: {
          id: "define.inventory.mealplan",
          defaultMessage: "Pensiones",
        },
      },
      {
        id: 9,
        section: SECTION.INVENTORY_LINES_EXCEL,
        route: "inventoryMultiUpdate",
        title: {
          id: "define.inventory.inventoryExcel",
          defaultMessage: "Editar inventario por excel",
        },
      },
    ],
    []
  );

  return (
    <>
      <ParagraphStyled style={{ background: "#e4e4e4", textAlign: "center", padding: "4px" }}>
        <TitleSectionStyled>
          <FormattedMessage {...messages.inventoryTitle} />
        </TitleSectionStyled>
        <span>
          <FormattedMessage {...messages.title} />
        </span>
      </ParagraphStyled>
      <ContainerSection>
        <TitleStyled>
          <FormattedMessage {...messages.title} />
        </TitleStyled>
        {dynamicSections.map((menuSection: any) => (
          <ContainerMenuItemStyled>
            <AccordionMenuItem
              message={menuSection?.title}
              href={menuSection?.href}
              route={menuSection?.route}
              section={menuSection?.section}
              showSvg
            />
          </ContainerMenuItemStyled>
        ))}
        {menuSections.map(menuSection => (
          <ContainerMenuItemStyled>
            <AccordionMenuItem
              message={menuSection.title}
              href={menuSection.href}
              route={menuSection.route}
              section={menuSection.section}
              showSvg
            />
          </ContainerMenuItemStyled>
        ))}
      </ContainerSection>
    </>
  );
};

export default AccordionMenu;
